module.exports = __webpack_public_path__ + "static/media/11_motion-sensing-module.d83ea846.mp4";